import { sanitizeHtml } from '@realadvisor/html-sanitizer';
import { setupRenderer } from '@realadvisor/template-renderer';

import { IMAGE_PROXY_DOMAIN } from '@shared/config';
import { type Language, getLocale } from '@shared/LocaleContext';

const SANITIZE_OPTIONS = {
  tagsBlacklist: ['script'],
  attrsBlacklist: ['onclick'],
  attrsWithScheme: ['href'],
  allowedSchemes: ['http', 'https', 'mailto', 'tel'],
  selfClosingTags: [] as string[],
};

export const createTemplateRenderer = ({
  countryCode,
  language,
  translations,
  sanitize = str => sanitizeHtml(str, SANITIZE_OPTIONS),
}: {
  countryCode: string;
  language: Language;
  translations: Record<string, string> | undefined;
  sanitize?: (html: string) => string;
}) =>
  setupRenderer({
    imageProxyDomain: IMAGE_PROXY_DOMAIN,
    mainLocale: getLocale(countryCode, language, true),
    dateFnsLocale: language,
    translations,
    sanitize,
  });
